import { render, staticRenderFns } from "./MultipleFileContextMenu.vue?vue&type=template&id=7f36b516&"
import script from "./MultipleFileContextMenu.vue?vue&type=script&lang=js&"
export * from "./MultipleFileContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports